import { render } from "./CategoryTags.vue?vue&type=template&id=314d2c68"
import script from "./CategoryTags.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryTags.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/product-categorization-drag-drop/components/filter/CategoryTags.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "314d2c68"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('314d2c68', __exports__)) {
    api.reload('314d2c68', __exports__)
  }
  
  module.hot.accept("./CategoryTags.vue?vue&type=template&id=314d2c68", () => {
    api.rerender('314d2c68', render)
  })

}


export default __exports__